export const AkamaiCookie = 'x-kbb-aka-data';